import React, { Fragment, useEffect, useState , useCallback} from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import BilledTo from "components/sales/formSection/billedTo/billedTo";
import PocDetails from "components/sales/formSection/pocDetails/pocDetails";
import Regex from 'services/utils/regex/Regex';
import { secondsToHours } from 'date-fns';
import { toast } from 'react-toastify';
import axios from 'axios';
import Config from 'services/config/config';

const ClientDetails = ({ data, locationPinCode, pincodeData, clientBillingPocData, clientBillingAddress, handleValue, prefilledData, isPocShow=true, isGstShow=false, setIsLoading, isPanRequired=false }) => {
  
  const [isNewClient, setIsNewClient] = useState(false);
  const [isNewAddress, setIsNewAddress] = useState(false);
  const [isNewPoc, setIsNewPoc] = useState(false);
  const [isEdit, setIsEdit] = useState(0);
  const [showData, setShowData] = useState('');
  const [showPan, setShowPan] = useState(isPanRequired === false ? false : true );
  const [clientPanDetails, setClientPanDetails] = useState({});
  const [clients, setClients] = useState(data?.clients);
  const [showClientOption, setShowClientOption] = useState(false);
  const [existingGst, setExistingGst] = useState(false);
  const [isGstSelected, setIsGstSelected] = useState(false);
  const [isGstValidated, setIsGstValidated] = useState(false);
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [existingAddressOptions, setExistingAddressOptions] = useState([]);
  const [isExistingAddressSelected, setIsExistingAddressSelected] = useState(false);
  const [selectedExistingAddress, setSelectedExistingAddress] = useState(null);
  const [showGstAddress, setShowGstAddress] = useState(false);
  const [existingClientPoc, setExistingClientPoc] = useState([]);
  const [showAddAddress, setShowAddAddress] = useState(false);
  
  const clientInput = {
    client_name: '',
    client_pan: '',
    client_gst:'',
    client_id: '',
    client_billing_id: '',
    client_billing_value: '',
    client_poc_id: '',
    client_poc_value: '',
    billing_address: '',
    poc_data: '',
    clientIdValue: { id: null, value: '' },
    panNumber: '',
    pan_required: isPanRequired === true ? true : '',
    client_type: ''
  };

  const clientbillingdataInput = {
    clientaddresses: [],
    clientPoc: []
  };
  
  const [clientbillingdata, setClientBillingData] = useState(clientbillingdataInput);
  const [clientData, setClientData] = useState(clientInput);

  const handleClientBlur = (client) => {
    // console.log('handleClientBlur');
    // console.log(clientData);
    if (
      Regex.number.test(client.id) &&
      !isNaN(client.id)
    ) {
    // console.log('inside handleClientBlur');
      setClientData({ 
        ...clientData, 
        client_id: client.id,
        client_billing_id: '',
        client_billing_value:'', 
        client_poc_id: '',
        client_poc_value:'' 
      });
      clientBillingAddress(client.id);
      
      // return false;
    } else {
    // console.log('handleClientBlur');
    // console.log(clientData);

      if (isEdit == 0) {
        // console.log('handleClientBlur');
        setClientData({ 
          ...clientData, 
          client_billing_id: '',
          client_billing_value:'', 
          client_poc_id: '',
          client_poc_value:'' 
        });
      }
    }
  };

  useEffect(() => {
    if (
      prefilledData?.client !== undefined &&
      prefilledData?.client !== null
    ) {
      const {
        id,
        client_name
      } = prefilledData?.client;
      let clientDataId = id;

      setTimeout(() => {
        setClientData({ 
          ...clientData, 
          client_id: clientDataId,
          client_name: client_name,
          clientIdValue: { id: clientDataId, value: client_name },
          client_type: 'existing_client'
        });
        handleClientBlur(clientData.clientIdValue);
        setShowData({
          ...showData,
          client_name: client_name
        });
      }, 100);
      // console.log(clientData);
      setIsEdit(1);
      setIsNewClient(false);
    }

    if (
      prefilledData?.client_leads_poc !== undefined &&
      prefilledData?.client_leads_poc !== null
    ) {
      const {
        id,
        name
      } = prefilledData?.client_leads_poc;
      let clientPocName = name;

      setTimeout(() => {
        setClientData({ 
          ...clientData, 
          client_poc_id: id,
          client_poc_value: name 
        });
        setShowData({
          ...showData,
          client_poc: name
        });
      }, 100);
      // console.log(clientData.client_poc_id);
    }

    if (
      prefilledData?.bill_to !== undefined &&
      prefilledData?.bill_to !== null
    ) {
      const {
        id,
        address_line_1,
        address_line_2,
        geo_city,
        geo_state,
        geo_pin
      } = prefilledData?.bill_to;
      let clientBillId = id;

      setTimeout(() => {
        setClientData({ 
          ...clientData, 
          client_billing_id: id,
          client_billing_value: address_line_1+ ' ' +address_line_2+' '+geo_city+' '+geo_state+' '+geo_pin, 
        });
        setShowData({
          ...showData,
          bill_address: address_line_1+ ' ' +address_line_2+' '+geo_city+' '+geo_state+' '+geo_pin
        });
      }, 100);
      // setShowData({
      //   client_name: client_name,
      //   client_poc: clientPocName,
      //   bill_address: address_line_1+ ' ' +address_line_2+' '+geo_city+' '+geo_state+' '+geo_pin
      // })
      // console.log(clientData.client_billing_id);
    }
  }, [prefilledData]);

  useEffect(() => {
    setIsGstValidated(false);
    setShowClientOption(false);
  }, [isGstSelected]);
  
  useEffect(() => {
      if (clientBillingPocData !== undefined && clientBillingPocData !== null) {
        if (!Array.isArray(clientBillingPocData)) {
          let {
            clientbillingaddress,
            clientPoc
          } = clientBillingPocData;
          setClientData({
            ...clientData,
            
          })
          const updatedAddresses = [
            ...(clientbillingaddress || []),
            { id: 0, name: 'Other' }
          ];
          setClientBillingData({
            ...clientbillingdata,
            clientaddresses: updatedAddresses,
            clientPoc: clientPoc
          })
        }
      } else {
        setClientData({ ...clientData, client_billing_id: '', client_poc_id: '' });
      }
  }, [clientBillingPocData]);

  const handleBillTo = (val) => {
    setClientData({ ...clientData, billing_address: val });
  };

  const handlePocData = (val) => {
    setClientData({ ...clientData, poc_data: val });
  };
 
  const add_client = () => {
    setIsNewClient(true);  
    setIsNewAddress(false);
    setIsNewPoc(false);
    setClientData({ 
      ...clientData, 
      client_id: '',
      client_billing_id: '',
      client_billing_value:'', 
      client_poc_id: '',
      client_poc_value:'',
      client_type: 'new_client'
    });
  }

  const add_existing_client = () => {
    setIsNewClient(false);
  }

  const add_address = () => {
    setIsNewAddress(true);
    setShowAddAddress(false);
    setShowGstAddress(false);
    setClientData({ 
      ...clientData, 
      client_billing_id: '',
      client_billing_value:'', 
    });
  }

  const add_existing_address = () => {
    setIsNewAddress(false);
  }

  const add_poc = () => {
    setIsNewPoc(true);
    setClientData({ 
      ...clientData, 
      client_poc_id: '',
      client_poc_value:'' 
    });
  }

  const add_existing_poc = () => {
    setIsNewPoc(false);
  }

  const add_new_client = () =>{
    return (
        <Fragment>
            {/* <div className="form-group full-width">
                <a className="btn btn-transparent" onClick={add_existing_client}>
                {localization.addExistingClient}
                </a>
            </div> */}
            <FormSection title={localization.addClient}>  
            <ConstantInput
                required={true}
                label={localization.clientName}
                handleChange={(val) => {
                    setClientData({
                    ...clientData,
                    client_name: val,
                    });
                }}
                isStarRequired={true}
                value={clientData.client_name}
                disabled={clientPanDetails?.registered_name && clientPanDetails.registered_name !== null ? true : false}
            />
            {/* <ConstantInput
                label={localization.panNumber}
                // isStarRequired={true}
                handleChange={(val) => {
                    setClientData({
                    ...clientData,
                    client_pan: val,
                    });
                }}
            />  */}
        </FormSection>
        </Fragment>
    );
  };

  const add_new_address = () =>{
      return(
          <Fragment>
            <BilledTo
                handleValue={handleBillTo}
                locationPinCode={locationPinCode}
                pincodeData={pincodeData}
            />
            {isNewAddress ? 
                <div className="form-group full-width">
                    <a className="btn btn-transparent" onClick={add_existing_address}>
                    {localization.addExistingAddress}
                    </a>
                </div>
            : null}
          </Fragment>
      );
  };

  const add_new_poc = () =>{
    return(
        <Fragment>
            <PocDetails
                handleValue={handlePocData}
                appartmentDropDown={data}
                fromPostsales={true}
            />
            <br/>
            {isNewPoc ? 
              <div className="form-group full-width">
                  <a className="btn btn-transparent" onClick={add_existing_poc}>
                  {localization.addExistingPoc}
                  </a>
              </div>
            : null}
        </Fragment>
    );
  };

  const handleFormData = () => {
    if (clientData) {
      handleValue(clientData);
    } else {
      handleValue(null);
    }
  };

  const handleCheckPan = async () => {
    try {
      if (!clientData?.panNumber) {
        toast.error('PAN number is required');
        return false;
      }
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (clientData.panNumber.length === 10 && !panRegex.test(clientData.panNumber)) {
        toast.error("Invalid PAN format. It should be like ABCDE1234F.");
        return false;
      } else if (clientData.panNumber.length !== 10) {
        toast.error("Invalid PAN length.");
        return false;
      }
      setIsLoading(true);
      setExistingGst(false);
      const response = await axios.get(`${Config.client.getClientByPan}?client_pan=${clientData.panNumber}`);
      if (response !== null && response?.data) {
        const panPayload = response?.data?.response?.data ?? response?.data?.data;
        if (panPayload?.clients?.length > 0) {
          setShowClientOption(true);
          setShowAddAddress(true);
          setClientPanDetails(panPayload);
          setClients(panPayload?.clients);
          setClientData({
            ...clientData,
            client_type: 'existing_client'
          });
          setIsNewClient(false);
        } else if (
          (response?.data?.status === false || response?.data?.status === 1) &&
          response?.data?.message === 'Pan number is invalid'
        ) {
          setShowClientOption(false);
          setClientPanDetails({});
          setClientData({
            ...clientData,
            client_type: 'existing_client'
          });
          setIsNewClient(false);
          toast.error(response?.data?.message);
        } else {
          setShowAddAddress(true);
          setShowClientOption(true);
          setClientPanDetails(panPayload);
          setClientData({
            ...clientData,
            client_name: panPayload?.registered_name,
            client_type: 'new_client',
            client_pan: clientData.panNumber
          });
          setIsNewClient(true);
        }
      }
      setIsLoading(false);
    } catch (err) {
      const errMsg = err?.response?.data?.message ?? err?.response?.data?.response?.message;
      if (errMsg === 'Pan number is invalid') {
        setIsLoading(false);
        toast.error(errMsg);
        return;
      }
      setIsLoading(false);
      toast.error("Error in checking PAN Number");
      return;
    }
  }

  useEffect(()=>{
      if (selectedAddress?.value !== 'Other') {
          setIsAddressSelected(true);
          setShowAddAddress(false);
          const selected = addressOptions.find(opt => opt.id === selectedAddress?.id);
          if (selected) {
          setClientData({
            ...clientData,
            billing_address: {
              billGeoCityId: selected.city_id,
              billGeoStateId: selected.state_id,
              billPinId: selected.pincode,
              billAddressLine1: selected.addressLine1,
              billAddressLine2: selected.addressLine2,
              billGeoCity: selected.city,
              billGeoState: selected.state,
            }
          });
          }
      }
      else{
        setClientData({
          ...clientData,
          client_billing_id: 0,
          client_billing_value: selectedAddress?.value
        });
        setShowAddAddress(true);
        setIsAddressSelected(true);
      }
  },[selectedAddress])

  useEffect(()=>{
    if (selectedExistingAddress?.value !== 'Other') {
      setIsExistingAddressSelected(true);
      setShowGstAddress(false);
  }
  else{
    setShowGstAddress(true);
    setIsExistingAddressSelected(true);
  }

  },[selectedExistingAddress])

  const handleCheckGst = useCallback(async () => {
    let cancelled = false;
    setIsLoading(true);

    const clientGst = clientData.client_gst;
  
    try {
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!clientGst || clientGst.length !== 15 || !gstRegex.test(clientGst)) {
        toast.error("Invalid GST number");
        setIsLoading(false);
        return;
      }

      const response = await axios.get(`${Config.client.getDetailsByGst}?gst=${clientGst}`);
      const result = response?.data?.response;
  
      if (!cancelled && result?.status) {
        const addressList = result.data?.address ?? [];
        const pan = result.data?.pan ?? '';

        setAddressOptions(addressList);
        setSelectedAddress(null); 
        setIsAddressSelected(false);
        setIsGstValidated(true);
        setIsGstSelected(1);
        if(result?.data?.pan_details.clients.length > 0){
          setShowClientOption(true);
          setClientPanDetails(result?.data?.pan_details);
          if(result?.data?.pan_details.registered_name != null && result?.data?.pan_details.registered_name != ''){
            setClientData({
              ...clientData,
              client_name: result?.data?.pan_details.registered_name,
            });
          }
          setClientData({
            ...clientData,
            client_type: 'existing_client',
            panNumber: pan.toUpperCase(),
            client_pan: pan.toUpperCase()
          });
          setClients(result?.data?.pan_details?.clients);
          setIsNewClient(false);
          setExistingAddressOptions(result?.data?.client_address);
          setExistingClientPoc(result?.data?.client_poc);
        }
        else{
          setShowClientOption(true);
          setClientPanDetails(result?.data?.pan_details);
          setClientData({
            ...clientData,
            client_name: result?.data?.pan_details.registered_name,
            client_type: 'new_client',
            panNumber: pan.toUpperCase(),
            client_pan: pan.toUpperCase()
          });
          setIsNewClient(true);
          setExistingAddressOptions(result?.data?.client_address);
          setExistingClientPoc(result?.data?.client_poc);
        }

      } else if (!cancelled) {
        toast.error(result?.message || "GST validation failed");
        setIsGstValidated(false);
      }
    } catch (error) {
      if (!cancelled) {
        toast.error("Invalid or Inactive GST");
      }
    } finally {
      if (!cancelled) setIsLoading(false);
    }
  
    return () => {
      cancelled = true;
    };
  }, [clientData.client_gst]);

  const handleGstCall = async (billingAddressId) => {
    setExistingGst(false);
    if (billingAddressId) {
      const url = `${Config.client.fetchBillingGST}?billing_address_id=${billingAddressId}`;
      const gst = await axios.get(url);
      const gstValue = typeof gst.data === "string" ? gst.data : (gst.data?.data ?? gst.data?.response?.data ?? "");
      if (gst != null && gst.data != null) {
        setExistingGst(true);
        setClientData({ ...clientData, client_gst: gstValue });
      }else{
        setClientData({ ...clientData, client_gst: '' });
      }
    }
  }

  useEffect(()=>{
    setIsGstValidated(false);
    setClientBillingData(clientbillingdataInput);
    setShowAddAddress(false);
    setShowGstAddress(false);
    setShowClientOption(false);
  },[clientData.client_gst]);

  useEffect(() => {
    if(!isGstSelected==1 && !isGstValidated){
    if (clientData.client_billing_id != '') {
      handleGstCall(clientData.client_billing_id);
    } else {  
      setClientData({ ...clientData, client_gst: '' });
    }
  }
  }, [clientData.client_billing_id]);

  useEffect(() => {
    handleFormData();
  }, [clientData]);
// console.log('client');
// console.log(clientData);
  return (
    <FormSection title={localization.clientDetails}>
    {isEdit == 1 ?
      <div>
        <ul>
          <li>Client Name: {showData?.client_name}</li>
          <li>Client Name: {showData?.client_poc}</li>
          <li>Client Name: {showData?.bill_address}</li>
        </ul>
      </div>
      : ''
    }

    {
      // showPan &&
      <>
      <div className='full-width'>
          <DropDownInput
              data={[{ id: 1, name: "Yes" }, { id: 2, name: "No" }]}
              label={localization.gstConfirmation}
              required
              getIdValue={(val) => {
                  setIsGstSelected(val.id);
              }}
              isStarRequired={true}
          />
      </div>

      {
      isPanRequired === false &&
      <div className="full-width">
        <DropDownInput
          label={localization.isPanNumberReq}
          data={[
            { name: 'Yes', id: 1 },
            { name: 'No', id: 2 },
          ]}
          required={true}
          errorMsg={localization.errorPanReq}
          getIdValue={(val) =>{
              setClientData({
                ...clientData,
                pan_required: val.id == 1 ? true : false,
                client_type: val.id == 2 ? 'new_client' : 'existing_client'
              });
              setIsNewClient(val.id == 2 ? true : false)
              setExistingGst(false);
              setShowPan(val.id == 2 ? false : true);
              setShowClientOption(val.id == 2 ? true : false)
              setClientPanDetails({});
            }
          }
          isStarRequired={true}
        />
      </div>
    }
 
      {(isGstSelected && isGstSelected == 1) &&
        <div className='full-width'>
          <ConstantInput
            label='GST Number'
            isStarRequired={true}
            handleChange={(val) => {
                setClientData({
                ...clientData,
                client_gst: val.toUpperCase()
                });
            }}
            required={true}
            value={clientData?.client_gst}
          /> 
          <div className="form-group">
                <a className="btn btn-theme mb-2 btn-sm" onClick={handleCheckGst}>
                Check GST
                </a>
            </div>
        </div>
      }

      {((isGstSelected == 1 && isGstValidated) || isGstSelected ==2) && showPan &&
      <>
      <div className="full-width">
        <ConstantInput
          label={localization.panNumber}
          isStarRequired={true}
          handleChange={(val) => {
              setClientData({
              ...clientData,
              panNumber: val.toUpperCase(),
              client_pan: val.toUpperCase()
              });
          }}
          required={true}
          value={clientData?.panNumber}
          disabled={isGstSelected == 1 && isGstValidated && clientData?.panNumber}
        /> 
        {!isGstValidated &&
         <div className="form-group">
              <a className="btn btn-theme mb-2 btn-sm" onClick={handleCheckPan}>
              {localization.checkPan}
              </a>
          </div>
        }
      </div>
      </>}
      </>}
    
    {showClientOption == true &&
      <>
        {isNewClient === false && isEdit == 0 ? 
          <div className="full-width">
              <DropDownInput
                  
                  label={localization.selectClient}
                  data={clients}
                  required={true}
                  errorMsg={localization.requiredClientName}
                    getIdValue={(val) =>{
                      handleClientBlur(val);
                    }
                  }
                  value={clientData?.client_name}
                  isStarRequired={true}
              />
              {/* <div className="form-group">
                  <a className="btn btn-transparent" onClick={add_client}>
                  {localization.addClient}
                  </a>
              </div> */}
          </div>
          :
          (add_new_client())
          }

          {((isGstSelected===1 && isGstValidated) || isGstSelected==2) && isNewClient === false && isEdit == 0 && isNewAddress === false ? 
          <div className="full-width">
              <DropDownInput
                  label={localization.billingAddress}
                  data={clientbillingdata.clientaddresses}
                  required={true}
                  errorMsg={localization.requiredBillingAddress}
                  getIdValue={(val) =>{
                    setClientData({
                        ...clientData,
                        client_billing_id: val.id,
                        client_billing_value: val.value
                    });
                    setSelectedExistingAddress(val);
                  }
                  }
                  value={clientData?.client_billing_value.length > 0 ? clientData?.client_billing_value : ''}
                  isStarRequired={true}
              />
          </div>
          :
          (((isGstSelected == 1 && isGstValidated) || isGstSelected==2)&&add_new_address())
          }
          
          {(isGstSelected == 1 && isGstValidated && showGstAddress) &&
            <div className='full-width'>
                <DropDownInput
                    data={addressOptions}
                    label="Select GST Address"
                    required
                    getIdValue={(val) => {
                        if (val) {
                            setSelectedAddress(val);
                            setIsAddressSelected(true);
                        } else {
                            setSelectedAddress(null);
                            setIsAddressSelected(false);
                        }
                    }}
                    isStarRequired={true}
                />
            </div>
          }

          {(isGstSelected==2 || showAddAddress) &&
            <div className="form-group">
              <a className="btn btn-transparent" onClick={add_address}>
              {localization.addBillingAddress}
              </a>
            </div>
          }

          {(clientData.panNumber !== '' && isGstSelected == 2) &&
            <div className="form-group">
                  <ConstantInput
                      label={localization.gstNumber}
                      handleChange={(val) => {
                          setClientData({
                          ...clientData,
                          client_gst: val.toUpperCase(),
                          });
                      }}
                      value={clientData?.client_gst}
                      disabled={existingGst}
                  /> 
            </div>      
          }

          {isNewClient === false && isEdit == 0 && isNewPoc === false ? 
          <div className="full-width">
              <DropDownInput
                  
                  label={localization.clientPoc}
                  data={clientbillingdata.clientPoc}
                  required={true}
                  errorMsg={localization.requiredClientPoc}
                  getIdValue={(val) =>{
                  setClientData({
                      ...clientData,
                      client_poc_id: val.id,
                      client_poc_value: val.value
                  });
                  }
                  }
                  value={clientData.client_poc_value.length > 0 ? clientData.client_poc_value : ''}
                  isStarRequired={true}
              />
              {isPocShow &&
                <div className="form-group">
                    <a className="btn btn-transparent" onClick={add_poc}>
                    {localization.addPOCButton}
                    </a>
                </div>
              } 
          </div>
          :
          (add_new_poc())
          }
      </>
    }
    </FormSection>
  );
};

ClientDetails.propTypes = {
  handleValue: PropTypes.func,
};

export default ClientDetails;
